/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateUserHabitEventLogCommand } from '../model/createUserHabitEventLogCommand';
import { CreateUserHabitEventLogCommandResult } from '../model/createUserHabitEventLogCommandResult';
import { DecrementUserHabitEventLogCommand } from '../model/decrementUserHabitEventLogCommand';
import { DecrementUserHabitEventLogCommandResult } from '../model/decrementUserHabitEventLogCommandResult';
import { DeleteUserHabitEventLogCommandResult } from '../model/deleteUserHabitEventLogCommandResult';
import { IncrementUserHabitEventLogCommand } from '../model/incrementUserHabitEventLogCommand';
import { IncrementUserHabitEventLogCommandResult } from '../model/incrementUserHabitEventLogCommandResult';
import { InlineResponse404 } from '../model/inlineResponse404';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserHabitEventLogsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userHabitEventLogsDecrementPost(body?: DecrementUserHabitEventLogCommand, observe?: 'body', reportProgress?: boolean): Observable<DecrementUserHabitEventLogCommandResult>;
    public userHabitEventLogsDecrementPost(body?: DecrementUserHabitEventLogCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DecrementUserHabitEventLogCommandResult>>;
    public userHabitEventLogsDecrementPost(body?: DecrementUserHabitEventLogCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DecrementUserHabitEventLogCommandResult>>;
    public userHabitEventLogsDecrementPost(body?: DecrementUserHabitEventLogCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DecrementUserHabitEventLogCommandResult>('post',`${this.basePath}/UserHabitEventLogs/Decrement`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userHabitEventLogsIncrementPost(body?: IncrementUserHabitEventLogCommand, observe?: 'body', reportProgress?: boolean): Observable<IncrementUserHabitEventLogCommandResult>;
    public userHabitEventLogsIncrementPost(body?: IncrementUserHabitEventLogCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IncrementUserHabitEventLogCommandResult>>;
    public userHabitEventLogsIncrementPost(body?: IncrementUserHabitEventLogCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IncrementUserHabitEventLogCommandResult>>;
    public userHabitEventLogsIncrementPost(body?: IncrementUserHabitEventLogCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<IncrementUserHabitEventLogCommandResult>('post',`${this.basePath}/UserHabitEventLogs/Increment`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userHabitEventLogsPost(body?: CreateUserHabitEventLogCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateUserHabitEventLogCommandResult>;
    public userHabitEventLogsPost(body?: CreateUserHabitEventLogCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateUserHabitEventLogCommandResult>>;
    public userHabitEventLogsPost(body?: CreateUserHabitEventLogCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateUserHabitEventLogCommandResult>>;
    public userHabitEventLogsPost(body?: CreateUserHabitEventLogCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateUserHabitEventLogCommandResult>('post',`${this.basePath}/UserHabitEventLogs`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userHabitEventLogsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteUserHabitEventLogCommandResult>;
    public userHabitEventLogsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteUserHabitEventLogCommandResult>>;
    public userHabitEventLogsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteUserHabitEventLogCommandResult>>;
    public userHabitEventLogsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userHabitEventLogsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteUserHabitEventLogCommandResult>('delete',`${this.basePath}/UserHabitEventLogs/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
